import moment from "moment";

const PREVIEW_SALE =
  (process.env.VUE_APP_PREVIEW_SALE &&
    process.env.VUE_APP_PREVIEW_SALE === "true") ||
  false;

// BASEDATES
const NOW = moment();
const CURRENT_YEAR = Number(NOW.format("Y"));

const SALE_START_DATE = moment(`${CURRENT_YEAR}-12-27T07:00:00`);
const SALE_END_DATE = moment(`${CURRENT_YEAR}-12-31T15:00:00`);

const NEXT_SYLVESTER = moment(`${CURRENT_YEAR + 1}-01-01T00:00:00`);

const config = {
  saleStart: SALE_START_DATE,
  saleEnd: SALE_END_DATE,

  nextSylvester: moment().endOf("year"), // dont use NOW because you alter the const
  currentYear: CURRENT_YEAR,

  /**
   * Checks if the sale is currently active
   * was "isLive"
   * @returns {boolean}
   */
  isActiveSale() {
    if (PREVIEW_SALE) return true;
    return NOW.isBetween(SALE_START_DATE, SALE_END_DATE);
  },

  /**
   * Checks if the sale has ended, but sylvester is not yet (both need to be in the current year)
   * if not the same year, its idle state
   * needed for showing a hint on the preview page
   * @returns {boolean}
   */
  isEndedSale() {
    return NOW.isAfter(SALE_END_DATE) && NOW.isBefore(NEXT_SYLVESTER);
  },
};

export default config;
